import { KeyValue } from '@angular/common';
import { YesNoValue } from '../enums/yes-no-value.enum';

export const YES_NO_VALUES: KeyValue<YesNoValue, string>[] = [
  {
    key: YesNoValue.Yes,
    value: $localize`:@@app.route.arpa.enums.yes:Sí`
  },
  {
    key: YesNoValue.No,
    value: $localize`:@@app.route.arpa.enums.no:No`
  }
] as KeyValue<YesNoValue, string>[];
